exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-showcase .el-dropdown+.el-dropdown[data-v-242798e6]{margin-left:15px}.example-showcase .el-dropdown-link[data-v-242798e6]{cursor:pointer;color:#00f;display:flex;align-items:center}", ""]);

// exports
